import PasswordReset from "@/pages/PasswordResetConfirm";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

const PasswordResetConfirm = () => <PasswordReset />;

type PasswordResetConfirmSearch = {
  token: string;
  mode?: string;
};
export const Route = createFileRoute("/external/password_reset_confirm")({
  component: PasswordResetConfirm,
  validateSearch: (
    search: Record<string, string>,
  ): PasswordResetConfirmSearch => ({
    token: search.token,
    mode: search.mode,
  }),
});
